import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shared/components/ui/table';
import { MembershipRole, MembershipStatus } from '@/types/api/membership';
import { MembershipStatusBadge } from './membership-status-badge';
import { MembershipRoleBadges } from './membership-role-badges';

export type MembershipListItem = {
  user: string;
  roles: MembershipRole[];
  userId: string;
  status: MembershipStatus;
};

type MembershipListProp = {
  items: MembershipListItem[];
  onRowClick: (userId: string) => void;
};

export function MembershipList({ items, onRowClick }: MembershipListProp) {
  return (
    <Table className="table-fixed">
      <TableHeader>
        <TableRow className="hover:bg-transparent">
          <TableHead>Namn</TableHead>
          <TableHead>Roll</TableHead>
          <TableHead className="text-right md:text-left">Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.length > 0 ? (
          items.map((item) => (
            <TableRow
              key={item.userId}
              className="hover:cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                onRowClick(item.userId);
              }}
            >
              <TableCell className="font-medium">{item.user}</TableCell>
              <TableCell>
                <MembershipRoleBadges roles={item.roles} />
              </TableCell>
              <TableCell className="text-right md:text-left">
                <MembershipStatusBadge status={item.status} />
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={3} className="text-center py-6">
              Inga medlemskap hittades
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
